module.exports = __webpack_public_path__ + "img/title11.2ca11808.png";